(function initDropdownDemo() {
  const DROPDOWN_SELECTOR = '[data-dropdown]';
  const dropdowns = Array.from(document.querySelectorAll(DROPDOWN_SELECTOR));
  const TOP_CLASS = 'dropdown--position-top';
  const BOTTOM_CLASS = 'dropdown--position-bottom';

  const getParts = (dropdown) => ({
    button: dropdown.querySelector('.dropdown__button'),
    menu: dropdown.querySelector('.dropdown__menu'),
    moreButton: dropdown.querySelector('.dropdown__more-trigger'),
  });

  const isOpen = (dropdown) => dropdown.classList.contains('dropdown--open');
  const hasHiddenMoreItems = (dropdown) =>
    Boolean(
      dropdown.querySelector('.dropdown__menu .dropdown__item--hidden[hidden], .dropdown__menu .dropdown__item--hidden')
    );

  const setExpanded = (button, expanded) => {
    if (button) button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  };

  const setMenuHidden = (menu, hidden) => {
    if (menu) menu.setAttribute('aria-hidden', hidden ? 'true' : 'false');
  };

  const setMoreExpanded = (button, expanded) => {
    if (button) button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  };

  const updatePosition = (dropdown) => {
    const { menu } = getParts(dropdown);
    if (!menu) return;

    const rect = dropdown.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const needed = menu.scrollHeight + 12;

    if (spaceBelow < needed) {
      dropdown.classList.add(TOP_CLASS);
      dropdown.classList.remove(BOTTOM_CLASS);
    } else {
      dropdown.classList.add(BOTTOM_CLASS);
      dropdown.classList.remove(TOP_CLASS);
    }
  };

  const keepInView = (dropdown) => {
    const { menu } = getParts(dropdown);
    if (!menu) return;

    const rect = menu.getBoundingClientRect();
    const margin = 12;
    let delta = 0;

    if (rect.top < margin) {
      delta = rect.top - margin;
    } else if (rect.bottom > window.innerHeight - margin) {
      delta = rect.bottom - (window.innerHeight - margin);
    }

    if (Math.abs(delta) > 2) {
      window.scrollBy({ top: delta, behavior: 'smooth' });
    }
  };

  const openDropdown = (dropdown) => {
    const { button, menu } = getParts(dropdown);
    dropdown.classList.add('dropdown--open');
    setExpanded(button, true);
    setMenuHidden(menu, false);
    updatePosition(dropdown);
    requestAnimationFrame(() => keepInView(dropdown));
    syncExternalMoreVisibility();
  };

  const closeDropdown = (dropdown) => {
    const { button, menu } = getParts(dropdown);
    dropdown.classList.remove('dropdown--open');
    setExpanded(button, false);
    setMenuHidden(menu, true);
    syncExternalMoreVisibility();
  };

  const closeAll = (except) => {
    dropdowns.forEach((dropdown) => {
      if (dropdown !== except && isOpen(dropdown)) closeDropdown(dropdown);
    });
  };

  const syncExternalMoreVisibility = () => {
    dropdowns.forEach((dropdown) => {
      const externalMore = dropdown.querySelector('.dropdown__more-trigger');
      if (externalMore) {
        externalMore.hidden = !isOpen(dropdown) || !hasHiddenMoreItems(dropdown);
        setMoreExpanded(externalMore, false);
      }
    });
  };

  const expandMore = (dropdown, trigger) => {
    const menu = dropdown.querySelector('.dropdown__menu');
    if (!menu) return;

    menu.querySelectorAll('.dropdown__item--hidden').forEach((item) => {
      item.classList.remove('dropdown__item--hidden');
      item.hidden = false;
    });

    trigger.hidden = !hasHiddenMoreItems(dropdown);
    setMoreExpanded(trigger, true);
    openDropdown(dropdown);
  };

  dropdowns.forEach((dropdown) => {
    const { button, menu } = getParts(dropdown);
    if (!button || !menu) return;

    button.addEventListener('click', () => {
      if (isOpen(dropdown)) {
        closeDropdown(dropdown);
        return;
      }
      closeAll(dropdown);
      openDropdown(dropdown);
    });

    menu.addEventListener('click', (event) => {
      const more = event.target.closest('[data-action="show-more"]');
      if (more) {
        event.preventDefault();
        event.stopPropagation();
        expandMore(dropdown, more);
        return;
      }

      const item = event.target.closest('.dropdown__item');
      if (item && !item.hasAttribute('data-action')) closeDropdown(dropdown);
    });

    menu.addEventListener('keydown', (event) => {
      const more = event.target.closest('[data-action="show-more"]');
      if (!more) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      expandMore(dropdown, more);
    });

    dropdown.addEventListener('click', (event) => {
      const more = event.target.closest('[data-action="show-more"]');
      if (!more || !dropdown.contains(more)) return;
      event.preventDefault();
      event.stopPropagation();
      expandMore(dropdown, more);
    });

    dropdown.addEventListener('keydown', (event) => {
      const more = event.target.closest('[data-action="show-more"]');
      if (!more || !dropdown.contains(more)) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      expandMore(dropdown, more);
    });
  });

  document.addEventListener('pointerdown', (event) => {
    const clickedInside = event.target.closest(DROPDOWN_SELECTOR);
    const clickedActionIconsMore = event.target.closest('[data-action-icons-more]');
    if (!clickedInside && !clickedActionIconsMore) closeAll(null);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll(null);
  });

  window.addEventListener('resize', () => dropdowns.forEach(updatePosition));
  window.addEventListener('scroll', () => dropdowns.forEach(updatePosition), {
    passive: true,
  });

  syncExternalMoreVisibility();
})();
